'use strict';
import {getId} from '../../core-utilities/domain/ReduxUtils';
import {SortMethod} from '../../core-utilities/filters/SortMethod';


DataTagsFilterService.$inject = [
  '$filter',
];

/** @namespace */
export function DataTagsFilterService($filter) {

  this.createTagLinksFilter = createTagLinksFilter;
  this.sortDataTagsOptions = sortDataTagsOptions;
  this.sortByTagLinks = sortByTagLinks;

  /**
   *
   * @param tagLinkList
   * @returns {Object}
   * @memberof DataTagsFilterService
   */
  function createTagLinksFilter(tagLinkList) {
    const results = {};
    for (const tagLinkId in tagLinkList) {
      if (tagLinkList.hasOwnProperty(tagLinkId))
        results[tagLinkList[tagLinkId].tag] = true;
    }
    return results;
  }

  function sortDataTagsOptions(list, sortOptions) {
    if (SortMethod.valueOf(sortOptions.currentMethod) === $filter.SORT_METHODS.NONE) {
      return list.sort($filter.$sortByProperty('$id', true));
    } else {
      return list.sort($filter.$sortByProperty(sortOptions.property, sortOptions.currentMethod, true));
    }
  }

  function sortByTagLinks(dataTags, tagLinksFilter) {
    const inProject = [];
    const notInProject = [];
    let id;

    for (let i = 0; i < dataTags.length; i++) {
      id = getId(dataTags[i]);
      if (tagLinksFilter[id]) {
        inProject.push(dataTags[i]);
      } else {
        notInProject.push(dataTags[i]);
      }
    }

    return inProject.concat(notInProject);
  }
}



// WEBPACK FOOTER //
// ./src/js/data-tags/filters/DataTagsFilterService.js